import React from 'react'
import EquipmentCard from './EquipmentCard'

function EquipmentmobCard({data,getData}) {
  return (
    <div>
       <div className="w-full h-[calc(100vh-199px)] overflow-y-auto py-1 px-2">
    
          {data &&
            data.map((item, index) => (
              <EquipmentCard item={item} getData={getData} key={index} />
            ))}
            
      </div>
    </div>
  )
}

export default EquipmentmobCard
